export const EVEREST_PLUS_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@id": "https://everest.ind.br/#organization",
   "@type": "Organization",
   "name": "Everest",
   "url": "https://everest.ind.br",
   "logo": {
    "@type": "ImageObject",
    "url": "https://www.everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/produto/everest-plus#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Produtos",
     "item": "https://everest.ind.br/pt/produto"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Purificador de Água Everest Plus",
     "item": "https://everest.ind.br/pt/produto/everest-plus"
    }
   ]
  },
  {
   "@type": "Product",
   "@id": "https://everest.ind.br/pt/produto/everest-plus#product",
   "name": "Purificador de Água Everest Plus",
   "description": "Purificador de alta capacidade com refrigeração por compressor, desenvolvido para ambientes empresariais e escritórios de grande demanda. Fornece água gelada, natural ou misturada para até 30 pessoas por hora. Disponível somente em revendas autorizadas Everest.",
   "url": "https://everest.ind.br/pt/produto/everest-plus",
   "image": [
    "https://assets.everest.ind.br/images/Group_37300.original.png"
   ],
   "brand": {
    "@type": "Brand",
    "name": "Everest"
   },
   "manufacturer": {
    "@id": "https://everest.ind.br/#organization"
   },
   "model": "Everest Plus",
   "mpn": "EVEREST-PLUS",
   "category": "Comércio > Purificador de Água",
   "color": "Branco, Preto, Prata, Cereja",
   "material": "Aço galvanizado, Polipropileno, Cobre, Poliuretano, Latão, Aço inoxidável",
   "audience": {
    "@type": "Audience",
    "audienceType": "Uso comercial e industrial em ambientes de alta demanda"
   },
   "additionalProperty": [
    {
     "@type": "PropertyValue",
     "name": "Sistema de refrigeração",
     "value": "Compressor"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura média da água gelada",
     "value": "8°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de refrigeração",
     "value": "1,896 litros/hora (ambiente 32°C, água 27°C)"
    },
    {
     "@type": "PropertyValue",
     "name": "Armazenamento de água gelada",
     "value": "2 litros"
    },
    {
     "@type": "PropertyValue",
     "name": "Capacidade de atendimento",
     "value": "Até 30 pessoas por hora"
    },
    {
     "@type": "PropertyValue",
     "name": "Vida útil do refil",
     "value": "4.000 litros (9 a 12 meses)"
    },
    {
     "@type": "PropertyValue",
     "name": "Temperatura de trabalho",
     "value": "5°C a 42°C"
    },
    {
     "@type": "PropertyValue",
     "name": "Pressão da rede hidráulica",
     "value": "3 a 40 MCA (0,029 a 0,392 MPa)"
    },
    {
     "@type": "PropertyValue",
     "name": "Tensão",
     "value": "127V ou 220V – 60Hz"
    },
    {
     "@type": "PropertyValue",
     "name": "Consumo",
     "value": "100W"
    },
    {
     "@type": "PropertyValue",
     "name": "Instalação",
     "value": "Bancada ou Parede"
    },
    {
     "@type": "PropertyValue",
     "name": "Altura",
     "value": "39,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Largura",
     "value": "30,5 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Profundidade",
     "value": "37 cm"
    },
    {
     "@type": "PropertyValue",
     "name": "Peso",
     "value": "13,5 kg"
    },
    {
     "@type": "PropertyValue",
     "name": "Canal de venda",
     "value": "Disponível somente em revendas autorizadas"
    },
    {
     "@type": "PropertyValue",
     "name": "Certificação",
     "value": "INMETRO, ABRAFIPA"
    }
   ],
   "potentialAction": {
    "@type": "ViewAction",
    "target": "https://everest.ind.br/pt/produto/everest-plus"
   }
  }
 ]
}
